import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { CONTACT } from '@common/constants';
import { HeatAndGas } from '@modules/services/heatAndGas/HeatAndGas';

const TITLE = 'Gas & Central Heating Engineers in London | Qeeper';
const DESC = `Is your broiler giving you the cold shoulder treatment? Our Central heating engineers can turn up the heat back on. Call ${CONTACT.PHONE} today!`;

const URL = 'https://www.qeeper.co.uk/services/heating-and-gas';
const SEO_KEYWORDS =
  'central heating engineers, central heating services, boiler fitters near me, heating engineers, gas engineers london';

const HeatingAndGasPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <HeatAndGas />
    </>
  );
};

export default HeatingAndGasPage;
